import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import type { PolicySection } from '../../types/policy';
interface PolicyContentsProps {
  sections: PolicySection[];
  activeId: string;
}
const focusRing = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-600 focus-visible:ring-offset-2 focus-visible:ring-offset-ivory';
export function PolicyContents({
  sections,
  activeId
}: PolicyContentsProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const activeSection = sections.find(section => section.id === activeId);
  return <>
      {/* Mobile: collapsible contents */}
      <div className="lg:hidden sticky top-[73px] z-30 -mx-6 px-6 py-3 bg-ivory/95 backdrop-blur-sm border-b border-charcoal/10" data-id="element-245" data-mp="2cvxw8vfge31m">
        <button type="button" onClick={() => setMobileOpen(open => !open)} aria-expanded={mobileOpen} aria-controls="policy-contents-mobile" className={`w-full flex items-center justify-between gap-3 rounded-xl border border-purple-200 bg-white px-4 py-3 text-left ${focusRing}`} data-id="element-246" data-mp="27xmk2e1orgg8">
          <span className="min-w-0" data-id="element-247" data-mp="1xvkhio51shkv">
            <span className="block text-[11px] font-semibold uppercase tracking-[0.14em] text-purple-700" data-id="element-248" data-mp="1xuiz1ylpcst4">
              Contents
            </span>
            <span className="block truncate text-sm text-charcoal/80" data-id="element-249" data-mp="27v2z4xxhjr9r">
              {activeSection ? `${activeSection.number}. ${activeSection.title}` : 'Jump to a section'}
            </span>
          </span>
          <ChevronDownIcon aria-hidden="true" className={`w-5 h-5 shrink-0 text-purple-700 transition-transform duration-200 ease-out ${mobileOpen ? 'rotate-180' : ''}`} data-id="element-250" data-mp="1f65kd4shgclr" />
        </button>

        {mobileOpen && <nav id="policy-contents-mobile" aria-label="Privacy Policy sections" className="mt-2 max-h-[60vh] overflow-y-auto rounded-xl border border-purple-200 bg-white py-2" data-id="element-251" data-mp="rfia4cv3haw1">
            <ol className="text-sm" data-id="element-252" data-mp="ocvq0v08w4be">
              {sections.map(section => {
            const isActive = section.id === activeId;
            return <li key={section.id} data-id="element-253" data-mp="y3gkq7cssop1">
                    <a href={`#${section.id}`} onClick={() => setMobileOpen(false)} aria-current={isActive ? 'true' : undefined} className={`flex gap-2 px-4 py-2.5 ${focusRing} ${isActive ? 'text-purple-800 font-semibold bg-purple-50' : 'text-charcoal/75 hover:text-purple-800 hover:bg-purple-50'}`} data-id="element-254" data-mp="y6kstftdw4kz">
                      <span className="tabular-nums text-charcoal/40" data-id="element-255" data-mp="ah9zgjed5cgv">
                        {section.number}.
                      </span>
                      <span data-id="element-256" data-mp="1lt13oq8yblyb">{section.title}</span>
                    </a>
                  </li>;
          })}
            </ol>
          </nav>}
      </div>

      {/* Desktop: sticky index */}
      <nav aria-label="Privacy Policy sections" className="hidden lg:block sticky top-32 max-h-[calc(100vh-11rem)] overflow-y-auto pr-4" data-id="element-257" data-mp="1ydhkuijloju1">
        <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-purple-700 mb-4" data-id="element-258" data-mp="1odz388r5xa55">
          On this page
        </p>
        <ol className="space-y-1 border-l border-charcoal/10" data-id="element-259" data-mp="2c5e7w86ew3jk">
          {sections.map(section => {
          const isActive = section.id === activeId;
          return <li key={section.id} data-id="element-260" data-mp="23ckqo57emu32">
                <a href={`#${section.id}`} aria-current={isActive ? 'true' : undefined} className={`block -ml-px border-l-2 pl-4 py-1.5 text-sm leading-snug transition-colors duration-200 ease-out ${focusRing} ${isActive ? 'border-purple-600 text-purple-800 font-semibold' : 'border-transparent text-charcoal/65 hover:text-purple-800 hover:border-purple-300'}`} data-id="element-261" data-mp="23bj4p5ouon6k">
                  <span className="tabular-nums text-charcoal/40 mr-1.5" data-id="element-262" data-mp="178lyya3b7h54">
                    {section.number}.
                  </span>
                  {section.title}
                </a>
              </li>;
        })}
        </ol>
      </nav>
    </>;
}